import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.USER_ADMIN_UPDATE || '/user/rapidoo-admin/update')
  },

  method() {
    return 'POST'
  },

  format(payload) {
    const data = {
      email: payload.email,
      firstName: payload.firstName,
      lastName: payload.lastName,
    }
    if (payload.password && String(payload.password).trim().length > 0) {
      data.password = String(payload.password).trim()
    }
    return data
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || "Erreur lors de la modification de l'utilisateur",
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Utilisateur modifié avec succès',
      data: raw.data,
    }
  },
}
